import { app } from './Api';

export const getKpis = async () => {
    return app.get('kpis');
};

export const getKpi = async (slug) => {
    return app.get(`kpis/${slug}`);
};

export const postKpiData = async (slug, filtros = {}) => {
    return app.post(`kpis/${slug}/data`, { filtros });
};
